import { Flow } from "./Chart/script/FlowRunner";

// 1. 샘플 데이터 (양봉과 음봉을 명확히 보여주기 위한 설정)
const tutorialData = [
  { baseDd: "1" }, 
  { baseDd: "2", openPrice: 300, highPrice: 850, lowPrice: 150, closePrice: 700 }, // 양봉
  { baseDd: "3" },
  { baseDd: "4", openPrice: 700, highPrice: 850, lowPrice: 150, closePrice: 300 }, // 음봉
  { baseDd: "5" },
];

// 2. 공통 스타일
const commonBoxStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #ADADAD',
  borderRadius: '24px',
  padding: '24px',
  width: '300px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
};

const commonTitleStyle = { color: '#000000', fontWeight: 'bold', fontSize: '19px' };
const commonContentStyle = { fontSize: '16px', color: '#444', marginTop: '8px', lineHeight: '1.6' };
const commonBtnStyle = {
  backgroundColor: '#0378D8',
  color: '#ffffff',
  borderRadius: '8px',
  padding: '10px 20px',
  fontWeight: 'bold',
  marginTop: '16px',
  border: 'none',
  cursor: 'pointer'
};

export const flowEx: Flow[] = [
  // Step 1: 튜토리얼 시작
  {
    step: 1,
    action: [
      { type: 'ADD_REGION', payload: { id: 'main', width: "100%", height: '100%', top: '0%', left: '0%' } },
      { type: 'ADD_LAYER', payload: { regionId: 'main', width: "90%", height: '80%', top: '10%', left: '5%', layer: { id: 'price-layer', yAxis: { orient: 'right', showGrid: true, yMinAxisSource: 0, yMaxAxisSource: 1000 } } } },
      { type: 'ADD_LAYER', payload: { regionId: 'main', layer: { id: 'overlay-layer', zIndex: 50 } } },
      { type: 'ADD_LAYER', payload: { regionId: 'main', layer: { id: 'ui-layer', zIndex: 100 } } },
      { type: 'ADD_OBJECT', payload: { regionId: 'main', layerId: 'overlay-layer', object: { id: 'dim-overlay', type: 'rect', x: 0, y: 0, width: '100%', height: '100%', style: { fill: 'rgba(0,0,0,0.7)' } } } },
      { type: 'ADD_DATA', payload: { data: tutorialData } },
      {
        type: 'ADD_GRAPH',
        payload: {
          regionId: 'main', layerId: 'price-layer',
          graph: {
            id: 'candle-main', type: 'candle',
            mapping: { xAxis: 'baseDd', open: 'openPrice', close: 'closePrice', high: 'highPrice', low: 'lowPrice' },
            style: { positiveColor: '#ef5350', negativeColor: '#3686ff' }
          }
        }
      },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "50%",
          box: {
            id: 'box1', nextStep: 2,
            title: "📈 주식 차트 읽기",
            content: ["주식 가격을 한눈에 보는", "특별한 차트를 알려드릴게요!"],
            btnContent: "시작하기",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 2: 캔들차트란?
  {
    step: 2,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box1' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "50%", y: "50%", width: "60%", height: "70%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "15%",
          box: {
            id: 'box2', nextStep: 3,
            title: "🕯️ 캔들차트",
            content: ["초 모양이라서 '캔들'이라고 불러요.", "하루 동안의 주식 가격 변화를", "이 하나로 볼 수 있어요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle,
          }
        }
      }
    ]
  },
  
  // Step 3: 두 가지 색깔
  {
    step: 3,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box2' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "15%",
          box: {
            id: 'box3', nextStep: 4,
            title: "🎨 두 가지 색깔",
            content: ["빨간색과 파란색, 두 종류가 있어요.", "각각 다른 의미를 가지고 있답니다."],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle,
          }
        }
      }
    ]
  },
  
  // Step 4: 양봉에 집중
  {
    step: 4,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box3' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "40%",
          box: {
            id: 'box4', nextStep: 5,
            title: "🔴 빨간 캔들",
            content: ["먼저 빨간색부터 볼게요.", "이 캔들 하나로 4가지 가격을 알 수 있어요!"],
            btnContent: "어떻게요?",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 5: 하루의 시작 - 시가 개념
  {
    step: 5,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box4' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "60%",
          box: {
            id: 'box5', nextStep: 6,
            title: "⏰ 하루의 시작",
            content: ["주식 시장은 아침 9시에 열려요.", "그때 처음 거래된 가격을", "'시작 가격(시가)'이라고 해요."],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 6: 시가 위치 - 빨간색 아래
  {
    step: 6,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box5' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "65%", width: "15%", height: "10%", borderRadius: '5px' } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "70%",
          box: {
            id: 'box6', nextStep: 7,
            title: "📍 시작 가격 찾기",
            content: ["빨간 캔들에서는", "두꺼운 부분의 '맨 아래'가", "시작 가격이에요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 7: 하루의 마지막 - 종가 개념
  {
    step: 7,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box6' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "30%",
          box: {
            id: 'box7', nextStep: 8,
            title: "🌙 하루의 마지막",
            content: ["주식 시장은 오후 3시 30분에 닫혀요.", "그때 마지막 거래된 가격을", "'마감 가격(종가)'이라고 해요."],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 8: 종가 위치 - 빨간색 위
  {
    step: 8,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box7' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "35%", width: "15%", height: "10%", borderRadius: '5px' } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "30%",
          box: {
            id: 'box8', nextStep: 9,
            title: "📍 마감 가격 찾기",
            content: ["빨간 캔들에서는", "두꺼운 부분의 '맨 위'가", "마감 가격이에요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 9: 빨간색의 의미
  {
    step: 9,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box8' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "50%",
          box: {
            id: 'box9', nextStep: 10,
            title: "📈 가격이 올랐어요!",
            content: ["시작 가격보다 마감 가격이 높으면", "빨간색이 돼요.", "이걸 '양봉'이라고 불러요!"],
            btnContent: "알겠어요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 10: 꼬리 소개
  {
    step: 10,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box9' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "50%",
          box: {
            id: 'box10', nextStep: 11,
            title: "📏 위아래 선은 뭐예요?",
            content: ["하루 동안 가격이 오르락내리락했겠죠?", "위아래 얇은 선은", "그 움직임을 보여줘요!"],
            btnContent: "더 알고 싶어요",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 11: 고가 개념과 위치
  {
    step: 11,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box10' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'circle', x: "32.7%", y: "22.5%", radius: "3%" } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "20%",
          box: {
            id: 'box11', nextStep: 12,
            title: "⬆️ 가장 높았던 순간",
            content: ["위쪽 선의 끝이", "하루 중 '가장 비쌌던 가격(고가)'이에요.", "한순간 이만큼 올랐던 거예요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 12: 저가 개념과 위치
  {
    step: 12,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box11' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'circle', x: "32.7%", y: "77.5%", radius: "3%" } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "80%",
          box: {
            id: 'box12', nextStep: 13,
            title: "⬇️ 가장 낮았던 순간",
            content: ["아래쪽 선의 끝이", "하루 중 '가장 쌌던 가격(저가)'이에요.", "한순간 이만큼 떨어졌던 거예요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 13: 빨간 캔들 정리
  {
    step: 13,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box12' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "32.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "65%", y: "50%",
          box: {
            id: 'box13', nextStep: 14,
            title: "✅ 빨간 캔들 정리",
            content: ["아래: 시작 가격 | 위: 마감 가격", "위 선 끝: 최고 가격 | 아래 선 끝: 최저 가격", "빨간색 = 가격이 올랐어요!"],
            btnContent: "이해했어요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 14: 파란 캔들로 이동
  {
    step: 14,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box13' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "67.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "30%", y: "50%",
          box: {
            id: 'box14', nextStep: 15,
            title: "🔵 파란 캔들",
            content: ["이번엔 파란색을 볼게요.", "빨간색과 좀 다를 거예요!"],
            btnContent: "궁금해요",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 15: 파란 캔들 - 시가는 위!
  {
    step: 15,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box14' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "67.5%", y: "35%", width: "15%", height: "10%", borderRadius: '5px' } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "30%", y: "30%",
          box: {
            id: 'box15', nextStep: 16,
            title: "📍 시작 가격은 위!",
            content: ["파란 캔들은 양봉과 반대예요!", "두꺼운 부분의 '맨 위'가", "시작 가격이에요."],
            btnContent: "오! 반대네요",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 16: 파란 캔들 - 종가는 아래!
  {
    step: 16,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box15' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "67.5%", y: "65%", width: "15%", height: "10%", borderRadius: '5px' } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "30%", y: "70%",
          box: {
            id: 'box16', nextStep: 17,
            title: "📍 마감 가격은 아래!",
            content: ["그래서 두꺼운 부분의 '맨 아래'가", "마감 가격이에요.", "위에서 시작해서 아래로 내려왔죠?"],
            btnContent: "그렇네요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 17: 파란색의 의미
  {
    step: 17,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box16' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "67.5%", y: "50%", width: "15%", height: "80%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "30%", y: "50%",
          box: {
            id: 'box17', nextStep: 18,
            title: "📉 가격이 떨어졌어요!",
            content: ["시작 가격보다 마감 가격이 낮으면", "파란색이 돼요.", "이걸 '음봉'이라고 불러요!"],
            btnContent: "이해했어요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 18: 파란 캔들도 꼬리 있음
  {
    step: 18,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box17' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "30%", y: "50%",
          box: {
            id: 'box18', nextStep: 19,
            title: "📏 위아래 선도 똑같아요",
            content: ["파란 캔들도 위아래에 선이 있죠?", "위 끝: 최고 가격", "아래 끝: 최저 가격"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 19: 전체 보기 - 비교
  {
    step: 19,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box18' } },
      { type: 'ADD_MASK', payload: { regionId: 'main', layerId: 'overlay-layer', mask: { id: 'mask1', type: 'rect', x: "50%", y: "50%", width: "60%", height: "70%", borderRadius: 10 } } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "15%",
          box: {
            id: 'box19', nextStep: 20,
            title: "🎯 한눈에 비교하기",
            content: ["빨간색(양봉): 가격 상승 ↗️", "파란색(음봉): 가격 하락 ↘️", "색깔만 봐도 알 수 있어요!"],
            btnContent: "쉽네요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 20: 실전 팁
  {
    step: 20,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box19' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "15%",
          box: {
            id: 'box20', nextStep: 21,
            title: "💡 실전 꿀팁",
            content: ["캔들이 길수록 가격 변화가 컸어요.", "위아래 선이 길면 하루 동안", "가격이 많이 흔들렸다는 뜻이에요!"],
            btnContent: "다음",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  },
  
  // Step 21: 마무리
  {
    step: 21,
    action: [
      { type: 'REMOVE_NEXT_BTN_BOX', payload: { regionId: 'main', layerId: 'ui-layer', boxId: 'box20' } },
      { type: 'REMOVE_OBJECT', payload: { regionId: 'main', layerId: 'overlay-layer', objectId: 'dim-overlay' } },
      {
        type: 'ADD_NEXT_BTN_BOX',
        payload: {
          regionId: 'main', layerId: 'ui-layer', x: "50%", y: "50%",
          box: {
            id: 'box21', nextStep: 22,
            title: "🎉 축하해요!",
            content: ["이제 캔들차트를 읽을 수 있어요!", "실제 차트에서 연습해보면", "금방 익숙해질 거예요!"],
            btnContent: "시작할게요!",
            BoxStyle: commonBoxStyle, titleStyle: commonTitleStyle, contentStyle: commonContentStyle, btnStyle: commonBtnStyle
          }
        }
      }
    ]
  }
];